import styled, { createGlobalStyle } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Line from 'common/assets/image/saasMinimal2/dotted-line.png';

export const GlobalStyle = createGlobalStyle`
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-family: 'DM Sans', sans-serif;
    margin-top: 0;
  }

  input,
  button,
  textarea {
    font-family: 'DM Sans', sans-serif;
  }

  figure {
    margin: 0;
  }
  
  section {
    position: relative;
  }

  .reuseModalHolder {
    border: 0 !important;
    background-color: transparent !important;
    
    &.video-modal {
      background-color: transparent !important;
      display: flex;
      align-items: center;
    }
    .innerRndComponent {
      height: auto;
      margin: 0 auto;
      width: 60%;
      @media only screen and (max-width: 1024px) {
        width: 90%;
      }
      @media only screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
  
`;

export const ContentWrapper = styled.div`
  overflow: hidden;
  .menuLeft {
    margin-left: 105px;
  }
  .menuRight {
    margin-left: auto;
  }

  .logo-container {
    .logo-sticky {
      display: none;
    }
  }

  .is-sticky {
    .navbar {
      background-color: #2D3033;
      box-shadow: 0px 6px 16px 0px rgba(43, 83, 135, 0.08);
    }
    .logo-container {
      .logo {
        display: none;
      }
      .logo-sticky {
        display: block;
      }
    }
    .menu-items {
      li {
        a {
          color: ${themeGet('colors.white')};
        }
        &:nth-last-child(2) a {
          border-bottom-color: rgba(0, 0, 0, 0.6);
          &:hover {
            color: ${themeGet('colors.white')};
          }
        }
        &:last-child a {
          color: ${themeGet('colors.white')};
        }
      }
      .is-current {
        a {
          color: ${themeGet('colors.white')};
        }
      }
    }
    .menubar {
      color: #fff;
    }
  }
  .process_item_col {
    &:nth-child(2),
    &:nth-child(3) {
      .process_item {
        &:before {
          content: '';
          background-image: url(${Line});
          width: 165px;
          height: 35px;
          display: block;
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          left: -165px;
          top: 20px;
          @media (max-width: 990px) {
            width: 100px;
            left: -80px;
          }
          @media (max-width: 767px) {
            display: none;
          }
        }
      }
    }
    &:nth-child(3) {
      .process_item {
        &:before {
          transform: rotate(180deg);
        }
      }
    }
  }
`;
